import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateBook = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [Data, setData] = useState({
    bookname: "",
    author: "",
    description: "",
    image: "",
    price: "",
  });

  // Fetch existing book data
  useEffect(() => {
    const fetchHandler = async () => {
      try {
        const res = await axios.get(`https://bookstore-backend-bk7y.onrender.com/api/v1/getBooks/${id}`);
        const book = res.data.book;
        setData({
          bookname: book.bookname || "",
          author: book.author || "",
          description: book.description || "",
          image: book.image || "",
          price: book.price || "",
        });
      } catch (error) {
        console.error("Error fetching book data:", error);
      }
    };
    fetchHandler();
  }, [id]);

  // Handle form input changes
  const change = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submission to update book
  const submit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.put(`https://bookstore-backend-bk7y.onrender.com/api/v1/updateBook/${id}`, Data);
      alert(res.data.message || "Book updated successfully");
      navigate("/books");  // Redirect to books page after update
    } catch (error) {
      console.error("Error updating book:", error);
      alert("Failed to update book");
    }
  };

  return (
    <div className="bg-dark d-flex justify-content-center align-items-center" style={{ minHeight: "91.5vh" }}>
      <div className="container p-4">
        <h3 className="text-white mb-3">Update Book</h3>
        <form onSubmit={submit}>
          <div className="mb-3">
            <label htmlFor="bookname" className="form-label text-white">Book Name</label>
            <input
              type="text"
              className="form-control"
              id="bookname"
              placeholder="Enter Book Name"
              name="bookname"
              value={Data.bookname}
              onChange={change}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="author" className="form-label text-white">Author</label>
            <input
              type="text"
              className="form-control"
              id="author"
              placeholder="Enter Author Name"
              name="author"
              value={Data.author}
              onChange={change}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label text-white">Description</label>
            <input
              type="text"
              className="form-control"
              id="description"
              placeholder="Enter Description of The Book"
              name="description"
              value={Data.description}
              onChange={change}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="image" className="form-label text-white">Image URL</label>
            <input
              type="text"
              className="form-control"
              id="image"
              placeholder="Enter The URL Of The Image"
              name="image"
              value={Data.image}
              onChange={change}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="price" className="form-label text-white">Price</label>
            <input
              type="number"
              className="form-control"
              id="price"
              placeholder="Enter Price"
              name="price"
              value={Data.price}
              onChange={change}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">Update Book</button>
        </form>
      </div>
    </div>
  );
};

export default UpdateBook;

